// Platform detection
const isDesktop = typeof window !== 'undefined' && '__TAURI__' in window;

class TabSyncManager {
  private channel: BroadcastChannel | null = null;

  constructor() {
    // Only use BroadcastChannel in web browsers, not in desktop (Tauri)
    if (!isDesktop && typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel('auth-sync');
    }
  }

  notifySignOut() {
    console.log('[TabSync] Broadcasting sign out notification');
    if (isDesktop) {
      // In desktop, use custom events since there's only one window
      window.dispatchEvent(new CustomEvent('auth-sync', { 
        detail: { type: 'SIGN_OUT' } 
      }));
    } else if (this.channel) {
      this.channel.postMessage({ type: 'SIGN_OUT' });
    }
  }

  notifyOnboardingComplete() {
    console.log('[TabSync] Broadcasting onboarding completion');
    if (isDesktop) {
      // In desktop, use custom events since there's only one window
      window.dispatchEvent(new CustomEvent('auth-sync', { 
        detail: { type: 'ONBOARDING_COMPLETE' } 
      }));
    } else if (this.channel) {
      this.channel.postMessage({ type: 'ONBOARDING_COMPLETE' });
    }
  }

  subscribe(callback: () => void) {
    console.log('[TabSync] Subscribing to sync events');
    
    if (isDesktop) {
      // Use custom events for desktop
      const handler = (event: CustomEvent) => {
        if (event.detail?.type === 'ONBOARDING_COMPLETE') {
          console.log('[TabSync] Received onboarding completion notification');
          callback();
        }
      };
      window.addEventListener('auth-sync', handler as EventListener);
      return () => {
        console.log('[TabSync] Unsubscribing from sync events');
        window.removeEventListener('auth-sync', handler as EventListener);
      };
    } else if (this.channel) {
      // Use BroadcastChannel for web
      const handler = (event: MessageEvent) => {
        if (event.data.type === 'ONBOARDING_COMPLETE') {
          console.log('[TabSync] Received onboarding completion notification');
          callback();
        }
      };
      this.channel.addEventListener('message', handler);
      return () => {
        console.log('[TabSync] Unsubscribing from sync events');
        this.channel?.removeEventListener('message', handler);
      };
    }
    
    // Return no-op cleanup function if neither platform is available
    return () => {};
  }

  subscribeToSignOut(callback: () => void) {
    console.log('[TabSync] Subscribing to sign out sync');
    
    if (isDesktop) {
      // Use custom events for desktop
      const handler = (event: CustomEvent) => {
        if (event.detail?.type === 'SIGN_OUT') {
          console.log('[TabSync] Received sign out notification');
          callback();
        }
      };
      window.addEventListener('auth-sync', handler as EventListener);
      return () => {
        console.log('[TabSync] Unsubscribing from sign out sync');
        window.removeEventListener('auth-sync', handler as EventListener);
      };
    } else if (this.channel) {
      // Use BroadcastChannel for web
      const handler = (event: MessageEvent) => {
        if (event.data.type === 'SIGN_OUT') {
          console.log('[TabSync] Received sign out notification');
          callback();
        }
      };
      this.channel.addEventListener('message', handler);
      return () => {
        console.log('[TabSync] Unsubscribing from sign out sync');
        this.channel?.removeEventListener('message', handler);
      };
    }
    
    // Return no-op cleanup function if neither platform is available
    return () => {};
  }

  cleanup() {
    console.log('[TabSync] Cleaning up channel');
    if (this.channel) {
      this.channel.close();
    }
  }
}

export const tabSync = new TabSyncManager();